export default __webpack_public_path__ + "static/media/template_business-man__0013_14---TalalSh.162733b9.png";